// removed by extract-text-webpack-plugin
module.exports = {"block":"YDeLcOmUosISc-eSeARO","inner":"_3YdW_8nbxc24XuEy_1ONN7","heading":"_1EX9bU5NwwBIgqZo5ZqeGv","intro":"_3WibgGv30ovuNa5qBMEpOs","links":"_2c4uZCfJKtavjl8EV2071T","links-item":"_2AsYNG1Qat-mOYfBjYOooA","link":"_3n7czyGkPR_Qhr5iOsZQgA","link-icon":"_27VyGDTm0K8NLXXtdTFC4D","link-text":"_1qmzSyrD_bBkJKrGiEmlDf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/BusinessAreaBlock/BusinessAreaBlock.module.scss
// module id = 737
// module chunks = 0